import { Center, Spinner } from '@chakra-ui/react';
import { FixedSizeList, ListChildComponentProps } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import InfiniteLoader from 'react-window-infinite-loader';

import MealItemCard from '~/components/MealItemCard';

import { FetchingDataStatus } from '~/types/utilities';
import { ItemCard } from './types';

import { PLATFORM_ID } from '~/globalVariables';

export default function MobileItemList({
  itemCount,
  items,
  fetchingStatusOfItem,
  onNavigateToItem,
  onLoadNextPage,
  onSetHeaderDisplay,
  onSetItemListRef,
}: {
  items: Array<ItemCard & { disabled?: boolean }>;
  itemCount: number;
  fetchingStatusOfItem: FetchingDataStatus;
  onLoadNextPage: () => void;
  onNavigateToItem: (storeId: string, itemId: string) => void;
  onSetHeaderDisplay: (val: boolean) => void;
  onSetItemListRef: (list: any) => void;
}) {
  const handleIsItemLoaded = (index: number) => itemCount === items.length || index < items.length;

  const handleRenderRow = ({
    style,
    index,
  }: React.PropsWithChildren<ListChildComponentProps<any>>) => {
    const item = items?.[index];
    if (!item && fetchingStatusOfItem === FetchingDataStatus.LOADING) {
      return (
        <Center h="135px">
          <Spinner size="lg" />
        </Center>
      );
    }
    if (!item) {
      return <></>;
    }
    return (
      <div style={style}>
        <MealItemCard
          key={`${item.storeId}${item.itemId || item.id || ''}`}
          name={item.name}
          image={item.image}
          price={item.price}
          disabled={item?.disabled}
          description={item.description}
          tags={item.tags[PLATFORM_ID] || []}
          onNavigate={() => onNavigateToItem(item.storeId, item.itemId || item.id || '')}
        />
      </div>
    );
  };

  return (
    <AutoSizer>
      {({ height, width }) => (
        <InfiniteLoader
          isItemLoaded={handleIsItemLoaded}
          itemCount={itemCount + 1}
          loadMoreItems={onLoadNextPage}
          minimumBatchSize={10}
        >
          {({ onItemsRendered, ref }) => (
            <FixedSizeList
              itemCount={itemCount + 1}
              onScroll={({ scrollOffset }) => onSetHeaderDisplay(scrollOffset ? false : true)}
              onItemsRendered={onItemsRendered}
              ref={(list) => {
                ref(list);
                onSetItemListRef(list);
              }}
              height={height}
              width={width}
              itemSize={135}
            >
              {handleRenderRow}
            </FixedSizeList>
          )}
        </InfiniteLoader>
      )}
    </AutoSizer>
  );
}
